const ColorsClassesPresets = [
  {
    prefix: "bg",
    property: "background-color"
  },
  {
    prefix: "text",
    property: ["color", "fill"]
  }
];
const getColorsClassesDefaultConfig = () => ColorsClassesPresets;
export {
  getColorsClassesDefaultConfig as g
};
//# sourceMappingURL=default.js.map
